import { constant, isFunction, get } from 'lodash';
import { modules } from 'veritone-redux-common';
import veritoneApi from '../helpers/veritoneApi';
import axios from 'axios';
import { ATTRIBUTE_APPLICATION_ID } from '../helpers/constant';

const { auth: authModule } = modules;

const {
  config: { getConfig }
} = modules;

export default async function callApi({
  actionTypes: [requestType, successType, failureType],
  query,
  body,
  variables,
  operationName,
  bailout = constant(false),
  dispatch,
  getState,
  file,
  url
}) {
  if (!isFunction(dispatch) || !isFunction(getState)) {
    throw new Error('callApi requires dispatch and getState functions');
  }

  const state = getState();
  const config = getConfig(state);
  const token = authModule.selectSessionToken(state);
  const endpoint = `${config.apiRoot}/${config.graphQLEndpoint}`;

  dispatch({ type: requestType, meta: { variables, operationName, query } });

  let response;

  if (file) {
    response = await multiPartRequest(
      endpoint,
      token,
      query,
      variables,
      operationName,
      dispatch,
      failureType,
      file
    );
  } else if (url) {
    response = {
      data: await jsonDownload(url, dispatch, failureType)
    };
  } else {
    throw new Error('Unexpected parameters set');
  }

  if (!response.data) {
    dispatch({
      type: failureType,
      error: true,
      payload: response.errors,
      meta: { variables, operationName, query }
    });

    let error = new Error('API response included errors');
    error.errors = response.errors;

    return error;
  } else {
    dispatch({
      type: successType,
      payload: response.data,
      meta: { variables, operationName, query }
    });

    return response.data;
  }
}

async function jsonDownload(url, dispatch, failureType) {
  try {
    return await fetch(url, {
      method: 'get'
    }).then(r => {
      return r.json();
    });
  } catch (e) {
    dispatch({
      type: failureType,
      error: true,
      payload: e
    });

    let error = new Error('API call failed');
    error.errors = [e];
    return error;
  }
}

async function multiPartRequest(
  endpoint,
  token,
  query,
  variables,
  operationName,
  dispatch,
  failureType,
  file
) {
  const blob = new Blob([file], { type: 'application/octet-binary' });
  try {
    const formData = new FormData();

    formData.append('query', query);
    formData.append('variables', JSON.stringify(variables));
    formData.append('filename', 'udrs.json');
    formData.append('file', blob, 'udrs.json');

    return await fetch(endpoint, {
      method: 'post',
      body: formData,
      headers: {
        Authorization: token ? `bearer ${token}` : null
      }
    }).then(r => r.json());
  } catch (e) {
    dispatch({
      type: failureType,
      error: true,
      payload: e,
      meta: { variables, operationName, query }
    });

    let error = new Error('API call failed');
    error.errors = [e];
    return error;
  }
}

function genGetTDOIdQuery(unsignUrl, dateNow, assetType) {
  return `
  mutation createTDOWithAsset1 {
    createTDOWithAsset(
      input: {
        startDateTime: ${dateNow}
        stopDateTime: ${dateNow}
        addToIndex: false
        assetType: "${assetType}"
        contentType: "application/xml"
        uri: "${unsignUrl}"
            }
        ) {
      id
    }
  }`
};

export function getTDOIdFile(urlApi, unsignUrl, dateNow, assetType) {
  return veritoneApi(urlApi.graphql)
    .post(
      '',
      { query: genGetTDOIdQuery(unsignUrl, dateNow, assetType) }
    )
    .then(response => get(
      response,
      'data.data.createTDOWithAsset.id',
      null
    )
    )
    .catch(error => ({
      error: true,
      ...error
    }))
}


export const fetchGraphQLApi = async function ({
  endpoint = 'https://api.veritone.com/v3/graphql',
  query,
  variables,
  operationName,
  token
}) {
  return await fetch(endpoint, {
    method: 'post',
    body: JSON.stringify({
      query,
      variables,
      operationName
    }),
    headers: {
      Authorization: token ? `bearer ${token}` : null,
      'Content-Type': 'application/json',
      'x-veritone-application': ATTRIBUTE_APPLICATION_ID
    }
  }).then(r => r.json());
};

export function downloadFileApi(url, name) {
  return axios({
    url,
    method: 'GET',
    responseType: 'blob'
  })
  .then(({ data }) => {
    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', name);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
    return { data };
  })
  .catch((error) => ({ error }));
}
